import { Typography,Button } from "@material-ui/core";
// Material components
import Grid from "@material-ui/core/Grid";
import { makeStyles, withStyles } from "@material-ui/core/styles";
// Externals
import PropTypes from "prop-types";
import React from "react";
import { useHistory } from "react-router";
import NotFounds from './components/NotFound';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(4),
	},
	content: {
		marginTop: "1rem",
		textAlign: "center",
	},
	image: {
		display: "inline-block",
		marginTop: "50px",
		maxWidth: "100%",
		width: "554px",
	},
}));

const NotFound = (props) => {
	const classes = useStyles();
  const history = useHistory()
	return (
		<div className={classes.root}>
			<Grid container justifyContent="center" spacing={3}>
				<Grid item lg={9} xs={12}>
					<div className={classes.content}>
						<Typography variant="h1">
							The page you are looking for isn’t here
						</Typography>
						<Typography variant="subtitle2">
							You either tried some shady route or you came here by mistake.
							Which ever it is, try using the navigation
						</Typography>
						<Button style={{border:"1px solid"}} onClick={() => history.push("/")}> Go Back</Button>
          <NotFounds />
          </div>
				</Grid>
			</Grid>
		</div>
	);
};

NotFound.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(NotFound);
